import React from 'react';
import './Contact.css';
import './About.css';
import'./Carwash.css';
import './Carwash.css';
import './Carwashslider.css';
import './App.css';



export default class Carwashslider extends React.Component{
    render()
    {
        return(
            <div>
<div class="fling-minislide">
  <img src="./images/wash1.jpg" alt="Slide 4" />
  <img src="./images/wash2.jpg" alt="Slide 3" />

  <img src="./images/wash3.jpg" alt="Slide 2" />

  <img src="./images/waash4.jpg" alt="Slide 1" />
</div>






            </div>
        )
    }
}